export { default as appLogo } from "./logo.svg";
export { default as logout } from "./logout.svg";
export { default as actions } from "./actions.svg";
export { default as down_Arr } from "./down_Arr.svg";
export { default as add } from "./add.svg";
export { default as left } from "./left.svg";
export { default as right } from "./right.svg";
export { default as success } from "./success.svg";
export { default as forerunnerIcon } from "./forerunner_icon.svg";
export { default as forerunnerIcon2 } from "./forerunner.svg";
export { default as leftArrIcon } from "./icon-park_left.svg";
export { default as eye } from "./eye.svg";
export { default as openedEye } from "./openedEye.svg";
export { default as successGreen } from "./success_green.svg";
export { default as verified } from "./verified.svg";
export { default as hourGlass } from "./time.svg";
export { default as navLogo } from "./navLogo.svg";
export { default as heroImg1 } from "./heroImg.png";
export { default as heroImg2 } from "./heroImg2.png";
export { default as whyUseImage } from "./whyUseImage.svg";
export { default as secondImage } from "./secondImage.png";
export { default as whatsapp } from "./whatsapp.svg";
export { default as email } from "./email.svg";
export { default as linkedin } from "./linkedin.svg";
export { default as instagram } from "./instagram.svg";
export { default as lineFooter } from "./lineFooter.svg";
export { default as back } from "./back.svg";
export { default as forward } from "./forward.svg";
export { default as bg_auth } from "./bg_auth.jpeg";
export { default as arrowRightUp } from "./arrowRighUp.svg";
export { default as peopleOutlineIcon } from "./peopleOutlineIcon.svg";
export { default as taskFilledIcon } from "./taskFilledIcon.svg";
export { default as verifiedBadgeIcon } from "./verifiedBadge.svg";
export { default as roundCancelIcon } from "./roundCancel.svg";
export { default as warningIcon } from "./warningIcon.svg";
export { default as HelpIcon } from "./HelpIcon.svg";
export { default as LogoutSmallIcon } from "./LogoutSmallIcon.svg";
export { default as SettingsIcon } from "./SettingsIcon.svg";
export { default as SinglePersonIcon } from "./SinglePersonIcon.svg";
export { default as PatientImg } from "./patientImg.svg";
export { default as VoiceCallIcon } from "./VoiceCallIcon.svg";
export { default as VideoCallIcon } from "./VideoCallIcon.svg";
export { default as ClockIcon } from "./clockIcon.svg";
export { default as DoctorIcon } from "./doctorIcon.svg";
export { default as NotificationIcon } from "./notification.svg";
